import React from 'react'
import PropTypes from 'prop-types'
import {Alert, Spinner} from 'reactstrap'
import i18next from 'i18next'
import {withTranslation} from 'react-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export default withTranslation('basic')(class WarningMessage extends React.Component {
    static defaultProps = {
        type : "default",
        spinner : "grow"
    }
    static propTypes = {
        msg : PropTypes.string,
        type : PropTypes.string,
        spinner : PropTypes.string
        //        t : PropTypes.func
    }
    render(){
        const {t,msg,type,spinner} = this.props
        const text = msg || t('error.'+type)
        return <Alert color="warning">
            <div className="d-flex flex-row">
                <div className="mr-2">
                    <FontAwesomeIcon size="2x" icon={["fad","exclamation-triangle"]} />
                </div>
                <div className="font-weight-bold m-auto">{text}</div>
            </div></Alert>
    }
})
